import { Row, Col, Layout } from 'antd';
import ManagerActionsComponent from '../Organism/ManagerActionsComponent';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
const { Content } = Layout;



const ManagerActions: React.FC = () => {

  return (
    <Layout style={{ backgroundColor: 'white' }}>
        <AppHeaderHomePageTemplate/>
        <Content style={{ padding: '0 50px',backgroundColor: 'white' }}>
          <ManagerActionsComponent />
        </Content>
    </Layout>
  );
};

export default ManagerActions;